export const DND_NODE = 'dnd_node';
export const DND_CONTENT_MODULE = 'dnd_content_module';
export const DND_CONTENT_COMPONENT = 'dnd_content_component';
export const DND_MENU_MODULE = 'dnd_menu_module';
